import React from "react";
import styles from "./HeroComponent.module.css";

const HeroComponent = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <h1 className={styles.title}>
          {/* Elevate Your Business with a <span className={styles.highlight}>Lead Engineer</span> Who Delivers. */}
          Smarter Systems. <br/> Better Workflow.
        </h1>
        <h2 className={styles.subtitle}>
          <span className={styles.highlight}>Custom CRMs and automation built to scale with your business.</span>
        </h2>
        <p className={styles.subtitle}>
          Let’s uncover where your business is leaking time, leads, and money — and fix it fast.        
        </p>
        <div className={styles.cta}>
          {/* <a href="/projects" className={`${styles.btn} ${styles.primaryBtn}`}>See My Work</a> */}
          <a href="/contact" className={`${styles.btn} ${styles.secondaryBtn}`}>Book a Free Strategy Call</a>
        </div>
      </div>
      
      {/* <div className={styles.imageContainer}>
        <img 
          src="/profileavatar.png" 
          alt="Daniel Rangel - Salesforce Developer and Engineer" 
          className={styles.heroImage} 
        />
      </div> */}
    </section>
  );
};

export default HeroComponent;
